import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as bookActions from '../../actions/bookActions';
import * as bookCardService from '../../services/domain/bookCardService';
import { Link } from 'react-router';
import CustomTooltip from './CustomTooltip';
import { prettyName } from '../../utils/stringUtils';
import { I18n } from 'react-redux-i18n-lite';

const SHOW_LAYER = 'layer showLayer';
const HIDE_LAYER = 'layer hideLayer';

class CustomBookCard extends React.Component {
  static propTypes = {
    goToUrl: PropTypes.string.isRequired,
    classroom: PropTypes.string.isRequired,
    importIsFetching: PropTypes.string,
    book: PropTypes.object.isRequired,
    bookOptions: PropTypes.object,
    renderLoadBar: PropTypes.func,
    renderSavedBookIcon: PropTypes.object,
    bookDefaultImg: PropTypes.any
  };

  constructor(props, context) {
    super(props, context);
    this.getBookImage = this.getBookImage.bind(this);
  }

  renderBookName = bookName => {
    const { bookOptions, goToUrl } = this.props;
    return (
      <div className="top">
        <span className="options">{bookOptions}</span>
        <Link to={goToUrl}>
          <div> {bookName} </div>
        </Link>
      </div>
    );
  };

  renderMetadata = bookMetadata => {
    return <div className="bottom">{bookMetadata}</div>;
  };

  renderTooltipWrapper = (title, children) => {
    return <CustomTooltip title={title}>{children}</CustomTooltip>;
  };

  getBookImage() {
    const { book, bookDefaultImg } = this.props;

    let bookImage = book.disabled ? 'book-card-image disabled' : 'book-card-image';
    let tempUrl = book.previewImage || book.image || bookDefaultImg;
    let backgroundImage = tempUrl ? { backgroundImage: `url(${tempUrl})` } : {};

    return <div className={bookImage} style={backgroundImage} />;
  }

  renderImportLoader() {
    const { importIsFetching, book } = this.props;
    const importLoaderClass = importIsFetching === book.activityId ? SHOW_LAYER : HIDE_LAYER;

    return (
      <div className={importLoaderClass}>
        <div className="importing-layer">
          <div className="loader">
            <div className="loader-inner ball-clip-rotate">
              <div />
            </div>
          </div>
          {I18n.t('common.copying')}
        </div>
      </div>
    );
  }

  render() {
    const { book, renderLoadBar, renderSavedBookIcon, goToUrl } = this.props;

    let bookCardInfo = book.disabled ? 'mid-bottom disabled' : 'mid-bottom';
    let showTopTooltip = false;
    let showBottomTooltip = false;
    let bookMetadataName = bookCardService.getPrimaryMetadataName(book.metadata);
    let bookPrettyName = prettyName(book.bookName, 38);
    let bookPrettyMetadataName = prettyName(bookMetadataName, 26);
    if (book.bookName.length > 38) {
      showTopTooltip = true;
    }
    if (bookMetadataName.length > 26) {
      showBottomTooltip = true;
    }
    let bookName = this.renderBookName(bookPrettyName);
    let metadata = this.renderMetadata(bookPrettyMetadataName);
    return (
      <div className="book-card">
        {this.getBookImage()}
        {this.renderImportLoader()}
        <div className="book-card-content">
          <Link to={goToUrl}>
            <div className="mid-top"></div>
          </Link>
          <div className={bookCardInfo}>
            {showTopTooltip ? this.renderTooltipWrapper(book.bookName, bookName) : bookName}
            <Link to={goToUrl}>
              {showBottomTooltip ? this.renderTooltipWrapper(bookMetadataName, metadata) : metadata}
            </Link>
            {renderSavedBookIcon}
          </div>
        </div>
        {renderLoadBar()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.account.user,
    i18n: state.i18n,
    isAppOnline: state.connection.status.online,
    bookDefaultImg: state.theme.images.placeholders.book,
    institution: state.school.school,
    selectedClassroom: state.classrooms.selectedClassroom.classroom,
    importIsFetching: state.library.importIsFetching
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bookActions: bindActionCreators(bookActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomBookCard);
